import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

export const Title = styled.h1`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  font-size: 24px;
  font-weight: 400;
  margin: 0 auto;
  text-align: center;
  color: ${COLORS.BLACK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-family: ${FONTS.MONTSERRAT_BOLD};
    font-size: 40px;
    text-align: center;
  }
`;

export const TopSection = styled.div`
  padding: 50px 15px;
  align-items: center;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 65px 60px 69px;
  }
`;

export const Title2 = styled.h2`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  color: ${COLORS.BLACK_BOLD};
  font-size: 20px;
  margin-bottom: 38px;
  text-align: left;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 24px;
  }
`;

export const Title3 = styled.h3`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  color: ${COLORS.BLACK_BOLD};
  font-size: 16px;
  margin-bottom: 24px;
  text-align: left;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Text = styled.div`
  font-size: 15px;
  color: ${COLORS.BLACK};
  font-family: ${FONTS.MONTSERRAT};
  margin-bottom: 24px;
  text-align: left;
`;

export const Wrapper = styled.div`
  padding: 50px 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 57px 0;
  }
`;

export const List = styled.ul`
  font-family: ${FONTS.MONTSERRAT};
  font-size: 15px;
  padding-left: 24px;
  text-align: left;
  margin-bottom: 20px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 28px;
  }
`;

export const Item = styled.li`
  margin-bottom: 15px;
  list-style: circle;
`;

export const ItemNumber = styled.li`
  margin-bottom: 15px;
  list-style: decimal;
`;

export const ImgDes = styled.img`
  display: none;
  margin-bottom: 20px;
  width: 560px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display:inline-block;
  }
`;

export const ImgMob = styled.img`
  display: none;
  margin-bottom: 20px;
  width: 240px;

  @media (max-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: inline-block;
  }
`;